import { BaseQueryFn, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { setError } from '../features/httpRequestFeedbackNotification/errorSlice';
import { store } from '../configuration/setup/store';
import { prepareHeaders } from '../configuration/tokenHandling/prepareHeaders';
import { Constants } from '../constants/Constants';

const { HTTP_ERROR_MAPPINGS } = Constants;

interface BaseQueryConfig {
    baseUrl: string;
}

const baseQueryWithErrorHandling = ({
    baseUrl,
}: BaseQueryConfig): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
    const baseQuery = fetchBaseQuery({ baseUrl, prepareHeaders });
    return async (args, api, extraOptions) => {
        try {
            const result = await baseQuery(args, api, extraOptions);
            const { error } = result;

            if (error && 'status' in error && error.status !== 403) {
                store.dispatch(
                    setError({
                        hasError: true,
                        message:
                            typeof error.status === 'number'
                                ? HTTP_ERROR_MAPPINGS[error.status] || 'Unexpected error occurred'
                                : 'Unexpected error occurred',
                    })
                );
            }
            return result;
        } catch (error) {
            store.dispatch(setError({ hasError: true, message: 'Unexpected error occurred' }));
            console.error('Unexpected Error:', error);
            return { error: { status: 'CUSTOM_ERROR', data: error } as FetchBaseQueryError };
        }
    };
};

export default baseQueryWithErrorHandling;
